import React from "react";
import { Navigate } from "react-router-dom";
import { useSuperAdminAuth } from "../context/SuperAdminAuthContext";
import { Loader2 } from "lucide-react";

export function SuperAdminProtectedRoute({ children, feature }) {
  const { sa, loading, has } = useSuperAdminAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "#0B0F14" }}>
        <Loader2 className="w-6 h-6 animate-spin text-cyan-400" />
      </div>
    );
  }
  if (!sa) return <Navigate to="/superadmin/login" replace />;
  if (feature && !has(feature)) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "#0B0F14", color: "#E5E7EB" }}>
        <div className="glass-card p-8 max-w-md text-center border border-white/10"
             style={{ background: "linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))" }}>
          <h2 className="text-xl font-display text-white mb-2">Feature not enabled</h2>
          <p className="text-sm text-white/70">Your super admin scope doesn&apos;t include <b className="text-cyan-300">{feature}</b>. Ask a master admin to grant access.</p>
        </div>
      </div>
    );
  }
  return children;
}
